import { useAtom } from 'jotai'
import { useSwiper } from 'swiper/react'

import ArrowIcon from 'assets/icons/arrow.svg'
import DigitalExperienceIcon from 'assets/icons/categories/Digital Experience.svg'
import InnovationIcon from 'assets/icons/categories/Innovation.svg'
import LiveIcon from 'assets/icons/categories/live.svg'
import LocalGemsIcon from 'assets/icons/categories/Local Gems.svg'
import MindBlowingIcon from 'assets/icons/categories/Mind-blowing Creativity.svg'
import ProductIcon from 'assets/icons/categories/prod.svg'
import RetailExperienceIcon from 'assets/icons/categories/Retail Experience.svg'
import TransformationCatalystIcon from 'assets/icons/categories/Transformation Catalyst.svg'
import BbThumbnail from 'assets/images/nma-no-image.jpg'
import { ModalAtom } from 'atoms/modals.atom'
import { WinnerTag } from 'components/WinnerTag'
import { AwardsFile } from 'types/AwardsFile'

export interface AwardCardProps {
  isActive?: boolean
  index?: number
  award: AwardsFile
}

const titleIcons: any = {
  'Product Experience': ProductIcon,
  'Live Experience': LiveIcon,
  'Local Gems': LocalGemsIcon,
  'Digital Experience': DigitalExperienceIcon,
  'Retail Experience': RetailExperienceIcon,
  'Mind-blowing Creativity': MindBlowingIcon,
  Innovation: InnovationIcon,
  'Transformation Catalyst': TransformationCatalystIcon,
}

export const AwardCard = (props: AwardCardProps) => {
  const [, setModalOpen] = useAtom(ModalAtom)
  const swiper = useSwiper()
  const handleOnClick = () => {
    if (!props.isActive) {
      swiper.slideToLoop(props.index ?? 0)
      return
    }
    if (award.year === 2023) {
      window.open(award.url, '_blank')
      return
    }
    setModalOpen({ isOpen: true, award })
  }
  const { award } = props
  const ouArray = award?.ou?.split(',')
  return (
    <div className="flex flex-col items-center transition-transform duration-300 justify-center">
      <div className="w-[532px] h-[58px] leading-[58px] rounded-t-xl bg-[#EBFF00] text-[24px] font-bold text-center flex justify-center uppercase">
        {titleIcons[award.category] && <img src={titleIcons[award.category]} alt="Category icon" className="mr-1" />}{' '}
        {award.category}
      </div>

      <div
        onClick={handleOnClick}
        className="w-[568px] h-[218px] rounded-2xl relative flex items-center justify-center group hover:shadow-[0px_14px_24px_0px_#0000000F] cursor-pointer"
      >
        <div className="absolute top-6 left-6 z-30">
          <WinnerTag />
        </div>
        <div className="z-10 absolute top-0 left-0 w-full h-full rounded-2xl bg-[#D7D7D7] transition-opacity " />
        <div className="z-20 w-[564px] h-[214px] p-4 bg-white rounded-[14px] flex">
          <div className="relative">
            <img
              src={award.thumbnail ?? BbThumbnail}
              alt={award.name}
              className="w-[280px] h-full rounded-lg object-cover"
            />
            <img src={award.brandLogoUrl} alt="" className="absolute right-0 top-0 w-14" />
          </div>
          <div className="flex flex-col px-4 w-full max-w-[246px] h-full whitespace-normal ">
            <p className="text-[12px] text-[#4C4C4C] font-TCCC font-bold capitalize">{award.tcccCategory}</p>
            <p className="text-[18px] font-semibold text-clip max-h-[160px] mt-1 mb-2 line-clamp-3">{award.name}</p>
            <p className="text-[14px] text-[#4C4C4C] font-TCCC font-semibold capitalize">
              {ouArray.map(
                (ou, index) => `${index < 4 ? ou : ''}${index < 3 && index + 1 !== ouArray.length ? ', ' : ''}`,
              )}
              {ouArray.length > 4 && `, +${ouArray.length - 4}`}
            </p>
            <div className="absolute flex bottom-4 right-4 group justify-between overflow-hidden ">
              <p className="mr-2 translate-x-32 origin-right font-bold overflow-hidden transition-all duration-300 whitespace-nowrap group-hover:translate-x-0 ">
                View {award.year !== 2023 ? 'entry' : 'file'}
              </p>
              <img src={ArrowIcon} alt="" className="bg-white" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
